import { Component } from "react";
import Header from "../components/header";
import Footer from "../components/footer";
import Hero from "../components/hero";
import ContactForm from "../components/contact_form";
import ChannelHowItWorks from "../components/channel_how_it_works";
import ChannelBenefits from "../components/channel_benefits";

class ChannelWithUs extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    const { isLoggedIn } = this.props;
    return (
      <>
        <div>
          <Header isLoggedIn={isLoggedIn} />

          <Hero
            title={
              <>
                Build the Future
                <br />
                of Education.
              </>
            }
            description="XLP invites partners and investors to bring future-ready learning programmes to schools and communities. By joining our network, you can introduce XLP services through your own channel while contributing to the growth of innovative education."
            buttonText="Become an XLP Partner"
            buttonLink="#how-it-works"
            imageSrc="assets-webp/misc/corporate-hands-unified.webp"
            background="linear-gradient(to bottom, #f0f4f8 0%, #ffffff 100%)" // Overriding the default background
          />

          <ChannelHowItWorks />

          <ChannelBenefits />

          <ContactForm
            title={<>Schedule a Conversation</>}
            description={
              <>
                Have questions about XLP Pulse or want to explore how you can be
                part of our mission to transform education? Reach out to us and
                our team will be happy to guide you.
              </>
            }
          />

          <Footer />
        </div>
      </>
    );
  }
}

export default ChannelWithUs;
